var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreatViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 32V1H31.4999V32H0.5Z",
    fill: "white",
    stroke: "#A7A3A3"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_4345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.4999V32H0.5V1Z",
    fill: "white",
    stroke: "#A7A3A3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_4345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72498 32.0312H15.7964V5.71088H5.72498V32.0312Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02502 2.42366V5.71016",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_4345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.4999V32H0.5V1Z",
    fill: "white",
    stroke: "#A7A3A3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_4345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05005 0.496155V5.70702",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 30.1984H23.093V16.1517H21.4375V30.1984Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.025 30.1984H19.6805V16.1517H18.025V30.1984Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.1547H14.0158V9.19131H7.5V11.1547Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.2047H14.0158V13.2412H7.5V15.2047Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.2547H14.0158V17.2912H7.5V19.2547Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.3046H14.0158V21.3413H7.5V23.3046Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 27.3563H14.0158V25.3928H7.5V27.3563Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27502 7.375H14.4783",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeDasharray: "20 13.33 20 13.33 466.67 20 13.33 20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_4345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.4999V32H0.5V1Z",
    fill: "white",
    stroke: "#A7A3A3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_4345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7288 32.0312H3.05005",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0038 32.0312H25.3251",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8012 10.1059C24.1456 10.7615 23.2739 11.1226 22.3467 11.1226C21.8105 11.1226 21.2929 11.0019 20.8251 10.7733",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeDasharray: "20 13.33 20 13.33 466.67 20 13.33 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8356 3.1839L18.8251 11.1945",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5751 3.6519V6.43515",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2766 8.56171H21.4501",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9529 5.46484H24.55",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 5.08553V9.4117",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.05 32.0312H25.3304V14.6474L17.05 10.6539",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7182 12.4805C24.5219 12.2562 25.2808 11.8294 25.9128 11.1974C27.8718 9.23835 28.9649 1.0509 28.9649 1.0509C28.9649 1.0509 20.7776 2.14403 18.8185 4.10308C17.3326 5.58884 16.9748 7.77446 17.7428 9.59852",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreatViews);
export default __webpack_public_path__ + "static/media/great_views.3b6d2bf2d69fa6bf5f14277049995a66.svg";
export { ForwardRef as ReactComponent };